import { useState, useEffect } from "react";
import { loadBillOfMaterialMOList } from "../services/billOfMaterialService";

const useBillOfMaterialMOList = (editID) => {

    const [moList, setMOList] = useState([]);
    const [selectedMO, setSelectedMO] = useState(null);
    const [selectedMONo, setSelectedMONo] = useState(null);
    const [selectedMOQty, setSelectedMOQty] = useState(0);
    const [isMODataLoaded, setIsMODataLoaded] = useState(false);

    // Fetch department data loadBillOfMaterialMOList
    const fetchProduct = async (selectedID = null,p_productvariety_id) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, p_productvariety_id: p_productvariety_id };

        try {
            const data = await loadBillOfMaterialMOList(para);
            if (data && data.length > 0) {
                setMOList(data);

                if (selectedID === 0) {
                    setSelectedMO([]);
                    setSelectedMONo([]);
                    setIsMODataLoaded(true);
                }
                else {
                    const initialMaterialCategory = data.find((dept) => dept.mo_number === selectedID);

                    if (initialMaterialCategory) { // ✅ Corrected check
                        setSelectedMO(initialMaterialCategory);
                        setSelectedMONo(initialMaterialCategory.mo_number);
                        setSelectedMOQty(initialMaterialCategory.prod_qty);
                        setIsMODataLoaded(true);
                    }
                }
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    // useEffect(() => {
    //     if (!isMODataLoaded && editID === 0) {
    //         fetchProduct();
    //     }
    // }, [isMODataLoaded, editID]);

    // Function to load department based on selected ID
    const loadMOByID = async (selectedID,p_productvariety_id) => {
        await fetchProduct(selectedID,p_productvariety_id);
    };

    return {
        moList,
        selectedMO,
        selectedMONo,
        setMOList,
        setSelectedMO,
        setSelectedMONo,
        loadMOByID,
    };
};

export default useBillOfMaterialMOList;
